import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
    Button,
    ButtonGroup,
    Container,
    Row,
    Col,
    Form,
    Modal,
    Spinner,
    Card,
    Alert,
    OverlayTrigger,
    Tooltip,
    Dropdown
} from "react-bootstrap";

import * as Yup from "yup";
import moment from "moment";
import { Formik } from "formik";
import { Typeahead } from "react-bootstrap-typeahead";

//Tabla, Navbar y Sidebar
import CustomNavbar from "../../../components/CustomNavbar";
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";
import SidebarCarreraSucesion from "../../../components/Carrera_Sucesion/SidebarCarreraSucesion";

//Redux
import {
    getResponsibleFactor,
    getOrganizationalUnits,
    getFactorsCriteria,
    editResponsibleFactor,
    saveResponsibleFactor,
    deleteResponsibleFactor
} from "../../../redux/Carrera_Sucesion/FactoresResponsables/actions";

import messages from "../../../redux/messages";
const FactoresResponsables = (props) => {
    const filters = [
        { id: "nombre_responsable", desc: "Nombre del responsable" },
        { id: "codigo_responsable", desc: "Código del responsable" },
        { id: "nombre_criterio", desc: "Nombre del criterio" },
        { id: "nombre_funcion", desc: "Nombre de la función" },
        { id: "codigo_funcion", desc: "Código de la función" },
        { id: "nombre_factor", desc: "Nombre del factor" },
        { id: "peso", desc: "Peso" },
        { id: "anio", desc: "Año" },
        { id: "fecha_creacion", desc: "Fecha de creación" },
        { id: "codigo_area", desc: "Código de Área" },
        { id: "nombre_area", desc: "Nombre de Área" }

    ];

    const [limit, setLimit] = useState(10);
    const [offset, setOffset] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    //
    const [edit, setEdit] = useState(false);
    const [showDetails, setShowDetails] = useState(false)
    const [index, setIndex] = useState(0);
    const [editItem, setEditItem] = useState({});
    const [editFactorCriterion, setEditFactorCriterion] = useState({});
    const [editUnidadOrganizativa, setEditUnidadOrganizativa] = useState({});
    const [isFuncionNotSelected, setIsFuncionNotSelected] = useState(true);

    const [factorCriterionSelected, setFactorCriterionSelected] = useState([]);
    const [_factorCriterion, setFactorCriterion] = useState(false);

    const [unidadOrganizativaSelected, setUnidadOrganizativaSelected] = useState([]);
    const [_unidadOrganizativa, setUnidadOrganizativa] = useState(false);
    //
    const [showModal, setShowModal] = useState(false);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [filter, setFilter] = useState("");
    const [validated, setValidated] = useState(false);
    const [show, setShow] = useState(false);
    const [factorsCriteriaOptionsByTask, setFactorsCriteriaOptionsByTask] = useState([])

    useEffect(() => {
        // Llamar a la función para obtener los factores de criterio disponibles
        getFactorCriterionOptions();
    }, []);

    // Función para obtener los factores de criterio disponibles
    const getFactorCriterionOptions = () => {

        let mockFactorCriterionOptions = []
        factorsCriteria.map((factorCriterion) => {
            mockFactorCriterionOptions = [
                ...mockFactorCriterionOptions,
                {
                    id: factorCriterion.id,
                    label: factorCriterion.list_criterios[0].nombre
                        ? ` ${factorCriterion.list_factor_criticidad[0].nombre.toUpperCase()} / ${factorCriterion.list_criterios[0].nombre.toUpperCase()}`
                        : "",
                    factorCriterion_id: factorCriterion.id,

                    item: factorCriterion,
                },
            ];
        });
        setFactorsCriteriaOptionsByTask(mockFactorCriterionOptions); // Establecer las opciones en el estado
    };

    //
    const [tipoBusqueda, setTipoBusqueda] = useState({
        id: "nombre_criterio",
        desc: "Nombre del Criterio",
    });
    const dispatch = useDispatch();

    const {
        loading,
        saveLoading,
        responsiblesFactorsLength,
        responsiblesFactors,
        responsibleFactorError,
        factorsCriteria,
        organizationalUnits,
        formError,
    } = useSelector((store) => store.responsibleFactor);
    const pages = Math.ceil(responsiblesFactorsLength / limit);

    //Validacion del form
    const schema = Yup.object().shape({
        area: Yup.string().required("**Campo requerido"),
        factores_criterios: Yup.string().required("**Campo requerido"),

    });




    //FactoresCriterios
    let factorsCriteriaOptions = [];
    factorsCriteria &&
        // eslint-disable-next-line array-callback-return
        factorsCriteria.map((factorCriterion) => {
            factorsCriteriaOptions = [
                ...factorsCriteriaOptions,
                {
                    id: factorCriterion.id,
                    label: factorCriterion.list_funcion[0].nombre
                        ? ` ${factorCriterion.list_funcion[0].codigo} / ${factorCriterion.list_funcion[0].descripcion.toUpperCase()}`
                        : "",
                    factorCriterion_id: factorCriterion.id,

                    item: factorCriterion,
                },
            ];
        });

    //funciones de factores criterios 
    let tasksFactorCriteriaOptions = [];
    let uniqueFunctions = {};

    factorsCriteria &&
        factorsCriteria.forEach((factorCriterion) => {
            const functionId = factorCriterion.list_funcion[0].id;
            if (!uniqueFunctions[functionId]) {
                uniqueFunctions[functionId] = true;
                tasksFactorCriteriaOptions.push({
                    id: factorCriterion.id,
                    label: factorCriterion.list_funcion[0].nombre
                        ? ` ${factorCriterion.list_funcion[0].codigo} / ${factorCriterion.list_funcion[0].descripcion.toUpperCase()}`
                        : "",
                    factorCriterion_id: factorCriterion.id,
                    item: factorCriterion,
                });
            }
        });

    //unidades organizativas
    let unidadesOrganizativasOptions = [];
    organizationalUnits &&
        // eslint-disable-next-line array-callback-return
        organizationalUnits.map((unidad) => {
            unidadesOrganizativasOptions = [
                ...unidadesOrganizativasOptions,
                {
                    id: unidad.id,
                    label: unidad.nombre
                        ? `${unidad.codigo} / ${unidad.nombre.toUpperCase()}`
                        : "",
                    item: unidad,
                },
            ];
        });



    //Datos para el custom table
    const columns = [
        {
            Header: "Factor",
            accessor: "nombre_factor",
            Filter: "",
            Cell: (value) => {
                const factoresCriterios = value.row.original?.list_factores_criterios;
                const factorCriticidad = factoresCriterios && factoresCriterios[0]?.list_factor_criticidad;

                return (
                    <div>
                        {factorCriticidad && factorCriticidad[0]
                            ? factorCriticidad[0].nombre
                            : "No ingresado"}
                    </div>
                );
            }
        },
        {
            Header: "Responsable",
            accessor: "nombre_responsable",
            Filter: "",
            Cell: (value) => (
                <div>
                    {value.row.original.list_unidad_organizativa &&
                        value.row.original.list_unidad_organizativa[0]
                        ? value.row.original.list_unidad_organizativa[0].nombre
                        : "No ingresado"}
                </div>
            ),
        },

        {
            Header: "Fecha de creación",
            accessor: "fecha_creacion",
            Filter: "",
            Cell: (value) => (
                <div>
                    {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
                </div>
            ),
        },
        {
            id: "customButtons",
            Filter: "",
            Cell: (value) => (
                <div className="button-group" role="group">
                    <Button
                        size="sm"
                        className="text-dark"
                        variant="link"
                        type="button"
                        onClick={() => onSeeDetails(value.row.original)}
                    >
                        <i className="material-icons">visibility</i>
                    </Button>
                    <Button
                        size="sm"
                        variant="link"
                        type="button"
                        onClick={() => onEdit(
                            value.row.original,
                            value.row.original.list_factores_criterios &&
                            value.row.original.list_factores_criterios,
                            value.row.original.list_unidad_organizativa &&
                            value.row.original.list_unidad_organizativa,
                            value.row.index
                        )}
                    >
                        <i className="material-icons">edit</i>
                    </Button>
                    <Button
                        size="sm"
                        className="text-danger"
                        variant="link"
                        type="button"
                        onClick={() => onDelete(value.row.original.id, value.row.index)}
                    >
                        <i className="material-icons">close</i>
                    </Button>

                </div>
            ),
        },
    ];




    // Metodos de factores criterios 
    const getAResponsibleFactor = (off = offset, lim = limit, filt = filter) =>
        dispatch(
            getResponsibleFactor({
                offset: off,
                limit: lim,
                tipo_busqueda: tipoBusqueda.id,
                filter:
                    tipoBusqueda.id === "fecha_creacion"
                        ? filt !== ""
                            ? !isNaN(filt)
                                ? filt
                                : `${filt.charAt(6)}${filt.charAt(7)}${filt.charAt(
                                    8
                                )}${filt.charAt(9)}-${filt.charAt(3)}${filt.charAt(
                                    4
                                )}-${filt.charAt(0)}${filt.charAt(1)}`
                            : filt
                        : filt,
            })
        );


    const getAFactorCriterion = () =>
        dispatch(
            getFactorsCriteria()
        );

    const getAOrganizationalUnit = () =>
        dispatch(
            getOrganizationalUnits()

        );


    useEffect(() => {
        getAFactorCriterion();
        getAOrganizationalUnit();
        getAResponsibleFactor();
    }, []);


    const addResponsibleFactor = () => {
        setShowModal(true);
        setEdit(false);
        setValidated(false);
    };

    const onEdit = (item, factorCriterio, unidadOrganizativa, index) => {
        console.log("item: ", item);

        setIndex(index);
        setEdit(true);
        setEditFactorCriterion(factorCriterio);
        setEditUnidadOrganizativa(unidadOrganizativa);
        setEditItem(item);
        setShowModal(true);
        setValidated(false);
    };

    const onSeeDetails = (item) => {
        setShowDetails(true);
        setShowDetailsModal(true);
        setEditItem(item);
    }

    const onSearch = (e) => {
        e.preventDefault();
        setFilter(e.target.filter.value);
        const oOffset = 0;
        setOffset(0);
        setCurrentPage(1);
        getAResponsibleFactor(oOffset, limit, e.target.filter.value);
    };


    const onSubmit = async (req) => {

        const _req = {
            ...req,

            factores_criterios: req.factores_criterios,
            area: req.area,
            fecha_creacion: moment(new Date()).format("YYYY-MM-DD"),
        };
        if (!edit) {
            console.log(_req);
            dispatch(saveResponsibleFactor(_req, setShowModal));
        } else {
            console.log("req", req);

            dispatch(editResponsibleFactor(_req, editItem.id, index, setShowModal));
        }
        setIsFuncionNotSelected(true)
    };



    const seeAll = () => {
        const oSearch = "";
        setFilter(oSearch);
        const oOffset = 0;
        setOffset(oOffset);
        setCurrentPage(1);
        getAResponsibleFactor(oOffset, limit, oSearch);
    };

    const onDelete = (id, index) => {

        if (window.confirm(messages.preguntaEliminar)) {
            dispatch(deleteResponsibleFactor(id, index));
            window.alert("Se borró este factor responsable");
        }
    };

    const onHandleFunctionSelected = (selectedOptions) => {
        setIsFuncionNotSelected(false)
        console.log(selectedOptions[0]?.item?.funcion)
        let mockFactorCriterionOptions = [];

        const selectedFunctionId = selectedOptions.length > 0 ? selectedOptions[0].item.funcion : null;
        const relevantFactors = selectedFunctionId
            ? factorsCriteriaOptions.filter(item => item.item.funcion === selectedFunctionId)
            : factorsCriteriaOptions;

        relevantFactors.forEach((factorCriterion) => {
            mockFactorCriterionOptions.push({
                id: factorCriterion.item.id,
                label: factorCriterion.item.list_criterios[0].nombre
                    ? `${factorCriterion.item.list_factor_criticidad[0].nombre.toUpperCase()} / ${factorCriterion.item.list_criterios[0].nombre.toUpperCase()}`
                    : "",
                factorCriterion_id: factorCriterion.item.id,
                item: factorCriterion.item,
            });
        });

        setFactorsCriteriaOptionsByTask(mockFactorCriterionOptions);
        setFactorCriterionSelected([]);

    };




    const onShowSidebar = () => setShow(show ? false : true);

    return (
        <>
            <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
            <SidebarCarreraSucesion show={show} onShowSidebar={onShowSidebar} />
            <div className="custom-wrapper">
                <Container fluid>
                    <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
                        <h6>Factores Responsables</h6>
                        <Form onSubmit={onSearch}>
                            <Row className="justify-content-sm-end align-items-center flex-nowrap">
                                <Col>
                                    <h6>
                                        <b>Busqueda por: {tipoBusqueda.desc}</b>
                                    </h6>
                                </Col>
                                <Col xs="auto">
                                    <Form.Control
                                        name="filter"
                                        id="filter"
                                        placeholder="Buscar"
                                        className="rounded-pill form-control-sm"
                                        type="search"
                                    ></Form.Control>
                                </Col>
                                <Col xs="auto">
                                    <ButtonGroup>
                                        <Button
                                            onClick={() => seeAll()}
                                            variant="light"
                                            size="sm"
                                            className="rounded-circle mr-1"
                                        >
                                            <i className="material-icons">list</i>
                                        </Button>
                                        <Button
                                            onClick={() => addResponsibleFactor()}
                                            variant="light"
                                            size="sm"
                                            className="rounded-circle"
                                        >
                                            <i className="material-icons">add</i>
                                        </Button>
                                        <OverlayTrigger
                                            placement="auto"
                                            overlay={
                                                <Tooltip {...props}>Seleccionar Filtrado</Tooltip>
                                            }
                                        >
                                            <Dropdown className="ml-3 mr-3">
                                                <Dropdown.Toggle
                                                    variant="light"
                                                    className="btn-sm font rounded-pill"
                                                >
                                                    <i className="material-icons">filter_list</i>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    {filters.map((item) => (
                                                        <Dropdown.Item
                                                            onClick={() => setTipoBusqueda(item)}
                                                            key={item.id}
                                                        >
                                                            {item.desc}
                                                        </Dropdown.Item>
                                                    ))}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </OverlayTrigger>
                                    </ButtonGroup>
                                </Col>
                            </Row>

                        </Form>
                    </div>

                    {loading ? (
                        <div className="d-flex justify-content-center">
                            <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                            />
                        </div>
                    ) : (
                        responsiblesFactorsLength > 0 && (
                            <>
                                <Card className="border-0">
                                    <Card.Body className="px-1 px-sm-2">
                                        <CustomTable columns={columns} data={responsiblesFactors} />
                                    </Card.Body>
                                </Card>
                                <CustomPagint
                                    limit={limit}
                                    setLimit={setLimit}
                                    offset={offset}
                                    setOffset={setOffset}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                    dataLenght={responsiblesFactorsLength}
                                    pages={pages}
                                    pagFunc={getAResponsibleFactor}

                                />
                            </>
                        )
                    )}
                    {!loading && responsiblesFactorsLength === 0 && responsiblesFactors === "" && (
                        <Alert variant="info" className="my-4">
                            Aún no hay registros, comience creando algunos.
                        </Alert>
                    )}
                    {!!responsibleFactorError && (
                        <Alert variant="danger" className="mt-4 mb-1 mx-3">
                            {responsibleFactorError}
                        </Alert>
                    )}
                </Container>
            </div>

            <Modal
                show={showModal}
                onHide={() => {
                    setShowModal(false);
                    setIsFuncionNotSelected(true);
                }}
            >
                <Formik
                    validationSchema={schema}
                    onSubmit={onSubmit}
                    initialValues={{
                        id: edit ? editItem.id : "",
                        factores_criterios: edit ? editFactorCriterion[0].id : "",
                        area: edit ? editUnidadOrganizativa[0].id : ""


                    }}

                >

                    {({
                        handleSubmit,
                        handleChange,
                        handleBlur,
                        setFieldValue,
                        values,
                        touched,
                        errors,
                    }) => (


                        <Form onSubmit={handleSubmit} noValidate validated={validated}>
                            {console.log(factorsCriteriaOptionsByTask)}
                            <Modal.Header closeButton>
                                <Modal.Title className="text-muted">
                                    {edit ? "Editar Factor Responsable" : "Crear Factor Responsable"}
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {!!formError && (
                                    <Alert variant="danger" className={"mt-4 mb-1 mx-3"}>
                                        {formError}
                                    </Alert>
                                )}

                                <Form.Group className="mb-3">
                                    <Form.Label column sm="12" md="12">
                                        Filtrar por Función:
                                    </Form.Label>
                                    <Row className="d-flex flex-wrap align-items-center">
                                        <Col sm={11} xs={11}>
                                            <Typeahead
                                                id="factores_criterios_funcion"
                                                name="factores_criterios_funcion"
                                                isInvalid={touched.factores_criterios && errors.factores_criterios}
                                                isValid={touched.factores_criterios && !errors.factores_criterios}
                                                onBlur={handleBlur("FactorCriterio_Funcion")}
                                                placeholder="Seleccione una función"
                                                options={tasksFactorCriteriaOptions}
                                                onChange={(selected) => {
                                                    setFieldValue(
                                                        "factores_criterios",
                                                        ""

                                                    );
                                                    onHandleFunctionSelected(selected)


                                                }}
                                                defaultInputValue={edit ? `${editFactorCriterion[0].list_funcion[0].descripcion}`
                                                    : ""}

                                            >

                                            </Typeahead>
                                        </Col>
                                    </Row>
                                    <Form.Label column sm="12" md="12" className="mt-4">
                                        Factor Criterio:
                                    </Form.Label>
                                    <Row className="d-flex flex-wrap align-items-center">
                                        <Col sm={11} xs={11}>
                                            <Typeahead
                                                id="factores_criterios"
                                                name="factores_criterios"
                                                disabled={!edit ? isFuncionNotSelected : false}
                                                isInvalid={touched.factores_criterios && errors.factores_criterios}
                                                isValid={touched.factores_criterios && !errors.factores_criterios}
                                                onBlur={handleBlur("Factor")}
                                                placeholder="Seleccione un factor criterio"
                                                options={factorsCriteriaOptionsByTask}
                                                value={values.factores_criterios}
                                                onChange={(selected) => {
                                                    setFieldValue(
                                                        "factores_criterios",
                                                        selected.length > 0 ? selected[0].id : "",

                                                    );

                                                    setFactorCriterionSelected(selected);
                                                    setFactorCriterion(selected.length > 0);


                                                }}
                                                defaultInputValue={edit ? `${editFactorCriterion[0].list_factor_criticidad[0].nombre} / ${editFactorCriterion[0].list_criterios[0].nombre}`
                                                    : ""}

                                            >

                                            </Typeahead>
                                        </Col>
                                    </Row>
                                    <Form.Label column sm="12" md="12">
                                        Responsable:
                                    </Form.Label>
                                    <Row className="d-flex flex-wrap align-items-center">
                                        <Col sm={11} xs={11}>
                                            <Typeahead
                                                id="area"
                                                name="area"
                                                isInvalid={touched.area && errors.area}
                                                isValid={touched.area && !errors.area}
                                                onBlur={handleBlur("Area")}
                                                placeholder="Seleccione un responsable"
                                                options={unidadesOrganizativasOptions}
                                                value={values.area}
                                                onChange={(selected) => {
                                                    setFieldValue(
                                                        "area",
                                                        selected.length > 0 ? selected[0].id : "",

                                                    );

                                                    setUnidadOrganizativaSelected(selected);
                                                    setUnidadOrganizativa(selected.length > 0);


                                                }}
                                                defaultInputValue={edit ? `${editUnidadOrganizativa[0].nombre}`
                                                    : ""}

                                            >

                                            </Typeahead>
                                        </Col>
                                    </Row>

                                </Form.Group>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    className="rounded-pill"
                                    variant="secondary"
                                    onClick={() => {
                                        setShowModal(false)
                                        setIsFuncionNotSelected(true)
                                    }}
                                >
                                    Cerrar
                                </Button>
                                <Button
                                    className="rounded-pill"
                                    variant="primary"
                                    disabled={saveLoading}
                                    type="submit"


                                >
                                    {" "}
                                    {saveLoading && (
                                        <Spinner
                                            className="mr-2"
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        />

                                    )}
                                    Guardar

                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>

            </Modal>



            <Modal
                show={showDetailsModal}
                onHide={() => {
                    setShowDetailsModal(false);
                }}
            >
                <Form>

                    <Modal.Header closeButton>
                        <Modal.Title className="text-muted">
                            Más Detalles
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>


                        <Form.Group className="mb-3">

                            <h6 className="my-2">Factor Criterio</h6>
                            <Form.Label column sm="12" md="12">
                                Función:
                            </Form.Label>
                            <Row className="d-flex flex-wrap align-items-center">
                                <Col sm={11} xs={11}>
                                    <Form.Control
                                        type="text"
                                        placeholder=""
                                        aria-label="Disabled input example"
                                        readOnly
                                        value={showDetails ? `${editItem.list_factores_criterios[0].list_funcion[0].codigo} / ${editItem.list_factores_criterios[0].list_funcion[0].descripcion}` : ""}

                                    />
                                </Col>
                            </Row>
                            <Form.Label column sm="12" md="12">
                                Criterio:
                            </Form.Label>
                            <Row className="d-flex flex-wrap align-items-center">
                                <Col sm={11} xs={11}>
                                    <Form.Control
                                        type="text"
                                        placeholder=""
                                        aria-label="Disabled input example"
                                        readOnly
                                        value={showDetails ? editItem.list_factores_criterios[0]?.list_criterios[0]?.nombre : ""}

                                    />
                                </Col>
                            </Row>
                            <Form.Label column sm="12" md="12">
                                Factor:
                            </Form.Label>
                            <Row className="d-flex flex-wrap align-items-center">
                                <Col sm={11} xs={11}>
                                    <Form.Control
                                        type="text"
                                        placeholder=""
                                        aria-label="Disabled input example"
                                        readOnly
                                        value={showDetails ? editItem.list_factores_criterios[0].list_factor_criticidad[0].nombre : ""}

                                    />
                                </Col>
                            </Row>
                            <Form.Label column sm="12" md="12">
                                Peso:
                            </Form.Label>
                            <Row className="d-flex flex-wrap align-items-center">
                                <Col sm={11} xs={11}>
                                    <Form.Control
                                        type="text"
                                        placeholder=""
                                        aria-label="Disabled input example"
                                        readOnly
                                        value={showDetails ? editItem.list_factores_criterios[0].peso : ""}

                                    />
                                </Col>
                            </Row>
                            <Form.Label column sm="12" md="12">
                                Año:
                            </Form.Label>
                            <Row className="d-flex flex-wrap align-items-center">
                                <Col sm={11} xs={11}>
                                    <Form.Control
                                        type="text"
                                        placeholder=""
                                        aria-label="Disabled input example"
                                        readOnly
                                        value={showDetails ? editItem.list_factores_criterios[0].anio : ""}

                                    />
                                </Col>
                            </Row>
                            <h6 className="my-3">Unidad Organizativa</h6>
                            <Row className="d-flex flex-wrap align-items-center">
                                <Col sm={11} xs={11}>
                                    <Form.Control
                                        type="text"
                                        placeholder=""
                                        aria-label="Disabled input example"
                                        readOnly
                                        value={showDetails ? editItem.list_unidad_organizativa[0].nombre : ""}

                                    />
                                </Col>
                            </Row>
                            <h6 className="my-3">Responsable</h6>
                            <Row className="d-flex flex-wrap align-items-center">
                                <Col sm={11} xs={11}>
                                    <Form.Control
                                        type="text"
                                        placeholder=""
                                        aria-label="Disabled input example"
                                        readOnly
                                        value={showDetails && editItem.list_responsable != null ? editItem?.list_responsable?.[0]?.nombre : "NO HAY UN RESPONSABLE ASOCIADO"}

                                    />
                                </Col>
                            </Row>
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            className="rounded-pill"
                            variant="secondary"
                            onClick={() => {
                                setShowDetailsModal(false)
                                setShowDetailsModal(false)
                            }}
                        >
                            Cerrar
                        </Button>

                    </Modal.Footer>
                </Form>


            </Modal>

        </>
    );
};

export default FactoresResponsables;
